// extracted by mini-css-extract-plugin
export default {"live-now":"styles_live-now__rxtRk","live-now--text":"styles_live-now--text__uKKkl"};